<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.recode') }}</div>
                <input v-model="searchParams.bookingCode" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelOptions"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.incurredTransactionReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              dom-layout="scroll"
              :rows="rows"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-size-cell="true"
              :suppress-row-transform="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Số phòng: Số phòng cụ thể</li>
            <li>Tên khách: Tên khách chính của đặt phòng</li>
            <li>Ngày đến: Ngày đến cửa đặt phòng</li>
            <li>Ngày đi: Ngày đi của đặt phòng</li>
            <li>
              Chi tiết dịch vụ: lấy theo danh sách dịch vụ tại bảng code (Tiền
              phòng, Minibar, Giặt là,..) và hiển thị số tiền của từng loại dịch
              vụ trong khoảng ngày được tìm kiếm
            </li>
            <li>Doanh thu: Doanh thu tổng của các dịch vụ được liệt kê</li>
            <li>
              Thanh toán: Các phương thức thanh toán được cấu hình và số tiền
              của từng phương thức thanh toán
            </li>
            <li>
              Hoàn tiền: Các phương thức hoàn tiền tại cấu hình và số tiền của
              từng phương thức được hoàn tiền
            </li>
            <li>
              Tổng : Tổng số tiền của từng cột dịch vụ và tổng của tất cả dịch
              vụ
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { getAllHotel } from '@/api/hotel.js'
import InfoBtn from './components/InfoBtn.vue'
import {
  getIncurredTransReportApi,
  getIncurredTransReportApiExcel
} from '@/api/report_service/report'
import dayjs from 'dayjs'
import { downFile } from '@/utils/file-handler'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'

const getDefaultSearchParams = () => ({
  dateFrom: dayjs().format('YYYY-MM-DD'),
  dateTo: dayjs().format('YYYY-MM-DD'),
  hotelId: [],
  bookingCode: null
})
const cellStyle = params => {
  if (params.data.rowSpan)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
      'border-left': '0.5px solid #ccc',
      'border-right': '0.5px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}

export default {
  components: {
    DasButton,
    CalendarSelect,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        bookingCode: null
      },
      defaultSsearchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        bookingCode: null
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      gridLoading: false,
      columns: [
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          // field: 'recode',
          // cellClass: "grid-cell-centered",
          tooltipField: 'recode',
          minWidth: 150,
          maxWidth: 150,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          sortable: false,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: this.$t('grid.column.roomNo'),
          field: 'room_num',
          // field: 'room_num',
          // cellClass: "grid-cell-centered",
          tooltipField: 'room_num',
          minWidth: 120,
          maxWidth: 120,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          sortable: false,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: this.$t('grid.column.guestName'),
          field: 'customer_name',
          tooltipField: 'customer_name',
          // field: 'customer_name',
          // tooltipField: 'customer_name',
          // cellClass: "grid-cell-centered",
          minWidth: 250,
          maxWidth: 300,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          sortable: false,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          // field: 'arrive_date',

          // cellClass: "grid-cell-centered",
          minWidth: 130,
          maxWidth: 130,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          sortable: false,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          // field: 'depart_date',
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          maxWidth: 130,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          sortable: false,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: this.$t('grid.column.invoiceCode'),
          field: 'invoice_code',
          // cellClass: "grid-cell-centered",
          tooltipField: 'invoice_code',
          minWidth: 120,
          maxWidth: 120,
          sortable: false,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: this.$t('grid.column.serviceDetail'),
          children: [
            // {
            //   field: 'room_charge',
            //   cellRenderer: params => this.$displayCurrency(params.value),
            //   tooltipValueGetter: params => this.$displayCurrency(params.value),
            //   headerName: this.$t('grid.column.revenue'),
            //   minWidth: 120,
            //   valueFormatter: params => {
            //     if (params.value !== null && params.value !== undefined) {
            //       return Number(params.value).toLocaleString('en')
            //     }
            //     return null
            //   }
            // },
            {
              field: 'room_charge',
              headerName: this.$t('grid.column.roomCharge'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),

              minWidth: 120
            },
            {
              field: 'minibar',
              headerName: this.$t('grid.column.miniBar'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),

              minWidth: 120
            },
            {
              field: 'extra_bed',
              headerName: this.$t('grid.column.extraBed'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),

              minWidth: 120
            },
            {
              field: 'extra_kid',
              headerName: this.$t('grid.column.extraPax'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 120
            },
            {
              field: 'laundry',
              headerName: this.$t('grid.column.laundry'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 120
            },
            {
              field: 'compensation',
              headerName: this.$t('grid.column.compensation'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 120
            },
            {
              field: 'spa',
              headerName: this.$t('grid.column.spa'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 120,
              headerClass: 'last-header-cell-group'
            },
            {
              field: 'restaurant',
              headerName: this.$t('grid.column.restaurant'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 120,
              headerClass: 'last-header-cell-group'
            },
            {
              field: 'other',
              headerName: this.$t('grid.column.other'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 120,
              headerClass: 'last-header-cell-group',
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                }
                return null
              }
            }
          ],
          // cellClass: "grid-cell-centered",
          // minWidth: 100,
          headerClass: ['header-cell-suffix-group', 'header-cell-center'],

          sortable: false
        },
        {
          headerName: this.$t('grid.column.revenueBeforeAdjust'),
          field: 'total',
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false,
          headerClass: [
            'header-row-span-2',
            'header-cell-suffix-group',
            'header-cell-center'
          ],
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          }
        },
        {
          headerName: this.$t('grid.column.payment'),
          headerClass: 'header-cell-center',
          children: [
            {
              field: 'card_payment',
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              headerName: this.$t('grid.column.card'),
              minWidth: 120
            },
            {
              field: 'cash_payment',
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              headerName: this.$t('grid.column.cash'),
              minWidth: 120
              // headerClass: 'last-header-cell-group'
            },
            {
              field: 'transfer_payment',
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              headerName: this.$t('grid.column.bankingTransfer'),
              minWidth: 120
              // headerClass: 'last-header-cell-group'
            },
            {
              field: 'debt_payment',
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              headerName: this.$t('grid.column.debt'),
              minWidth: 120
              // headerClass: 'last-header-cell-group'
            }
          ],
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.refund'),
          field: 'payment',
          children: [
            {
              field: 'transfer_back',
              headerName: this.$t('grid.column.bankingTransfer'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 150
            },
            {
              field: 'cashback',
              field: 'cashback',
              headerName: this.$t('grid.column.cash'),
              cellRenderer: params => this.$displayCurrency(params.value),
              tooltipValueGetter: params => this.$displayCurrency(params.value),
              minWidth: 150
            }
          ],
          headerClass: [
            'header-cell-suffix-group',
            'header-cell-center',
            'header-group-cell-divide'
          ],
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.revenueAfterAdjust'),
          field: 'total_after',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false,
          headerClass: [
            'header-row-span-2',
            'header-cell-suffix-group',
            'header-cell-center'
          ],
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          }
        }
      ],
      rows: [],
      pinnedBottomRowData: []
    }
  },
  async mounted() {
    await this.getHotelOptions()
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams = getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    convertRowData(rows) {
      let newRowData = []
      rows.forEach(item => {
        if (item.invoices?.[0]) {
          item.invoices[0] = {
            minibar: item.invoices[0].minibar,
            laundry: item.invoices[0].laundry,
            compensation: item.invoices[0].compensation,
            spa: item.invoices[0].spa,
            restaurant: item.invoices[0].restaurant,
            other: item.invoices[0].other,
            total: item.invoices[0].total,
            room_num: item.invoices[0].room_num,
            room_charge: item.invoices[0].room_charge,
            extra_bed: item.invoices[0].extra_bed,
            extra_kid: item.invoices[0].extra_kid,
            cash_payment: item.invoices[0].cash_payment,
            card_payment: item.invoices[0].card_payment,
            transfer_payment: item.invoices[0].transfer_payment,
            debt_payment: item.invoices[0].debt_payment,
            cashback: item.invoices[0].cashback,
            transfer_back: item.invoices[0].transfer_back,
            total_after: item.invoices[0].after,
            invoice_code: item.invoices[0].invoice_code,
            recode: item.recode,
            room_num: item.room_num,
            customer_name: item.customer_name,
            arrive_date: item.arrive_date,
            depart_date: item.depart_date,
            rowSpan: item.invoices.length
          }
          newRowData = [...newRowData, ...item.invoices]
        }
      })
      // console.log(newRowData)
      return newRowData
    },
    async attachData() {
      this.gridLoading = true
      getIncurredTransReportApi(this.searchParams)
        .then(res => {
          this.rows = this.convertRowData(res.data)
          this.pinnedBottomRowData = [
            {
              recode: 'Tổng',
              minibar: res.total_minibar,
              laundry: res.total_laundry,
              compensation: res.total_compensation,
              spa: res.total_spa,
              restaurant: res.total_restaurant,
              other: res.total_other,
              total: res.total_total,
              room_num: res.total_room_num,
              room_charge: res.total_room_charge,
              extra_bed: res.total_extra_bed,
              extra_kid: res.total_extra_kid,
              cash_payment: res.total_cash_payment,
              card_payment: res.total_card_payment,
              transfer_payment: res.total_transfer_payment,
              debt_payment: res.total_debt_payment,
              cashback: res.total_cashback,
              transfer_back: res.total_transfer_back,
              total_after: res.total_after
            }
          ]
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    async downloadExcel() {
      this.gridLoading = true
      getIncurredTransReportApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_giao_dich_phat_sinh_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
